export const isRemoteFileUrl = (url?: string): boolean =>
  Boolean(url && !url.startsWith('blob:') && !url.startsWith('data:'));
